<template>
  <footer>
    <div class="wrapper">
      <!--div class="bottom-img"></div-->
      <!-- <div class="clogowrap">
         <ul class="calogo">
           <li><img src="@/assets/img/ca_logo1.png" /></li>
           <li><img src="@/assets/img/ca_logo2.png" /></li>
           <li><img src="@/assets/img/ca_logo3.png" /></li>
           <li><img src="@/assets/img/ca_logo4.png" /></li>
           <li><img src="@/assets/img/ca_logo5.png" /></li>
           <li><img src="@/assets/img/ca_logo6.png" /></li>
           <li><img src="@/assets/img/ca_logo7.png" /></li>
           <li><img src="@/assets/img/ca_logo8.png" /></li>
           <li><img src="@/assets/img/ca_logo10.png" /></li>
         </ul>
      </div> -->
      <div class="footer_logo">
        <ul>
          <li class="logo_01"></li>
          <li class="logo_02"></li>
          <li class="logo_03"></li>
          <li class="logo_04"></li>
          <li class="logo_05"></li>
          <li class="logo_06"></li>
          <li class="logo_07"></li>
          <li class="logo_08"></li>
          <li class="logo_09"></li>
          <li class="logo_10"></li>
          <li class="logo_11"></li>
          <li class="logo_12"></li>
          <li class="logo_13"></li>
          <li class="logo_14"></li>
          <li class="logo_15"></li>
          <li class="logo_16"></li>
          <li class="logo_17"></li>
          <li class="logo_18"></li>
          <li class="logo_19"></li>
          <li class="logo_20"></li>
          <li class="logo_21"></li>
          <li class="logo_22"></li>
          <li class="logo_23"></li>
          <li class="logo_24"></li>
          <li class="logo_25"></li>
          <li class="logo_26"></li>
          <li class="logo_27"></li>
          <li class="logo_28"></li>
          <li class="logo_29"></li>
          <li class="logo_30"></li>
          <li class="logo_31"></li>
          <li class="logo_32"></li>
          <li class="logo_33"></li>
          <li class="logo_34"></li>
        </ul>
      </div>
      <div class="nav-bottom">
        <div class="footerInfo">
          <div class="footerl">
            <a class="flogo" @click="goPageByName('main')">
              <!-- <img src="@/assets/img/logo.png" /> -->
              <span class="copyright">Copyright 2026 BOOM. All Rights Reserved.</span>
            </a>
          </div>
          <!-- <div class="footerr">
            <ul class="footerNav">
              <li @click="goPageByName('qnaWrite')">{{ $t('front.common.qna')}}</li>
              <li @click="goPageByName('notice')">{{ $t('front.common.notice')}}</li>
              <li @click="goPageByName('faq')">{{ $t('front.common.faq')}}</li>
              <li @click="goPageByName('bettingGuide')">{{ $t('front.common.bettingGuide')}}</li>
              <li @click="goPageByName('result')">{{ $t('front.common.gameResult')}}</li>
              <li @click="goPageByName('boardList')">{{ $t('front.common.board')}}</li>
            </ul>
            <ul class="sns" v-if="siteOption">
              <li @click="siteOption['sns2Link']">
                <img src="@/assets/img/tele.svg" />
                <span>{{siteOption['sns2']}}<em>{{siteOption['sns2Id']}}</em></span>
              </li>
              <li @click="siteOption['sns1Link']">
                <img src="@/assets/img/kakao.svg" />
                <span>{{siteOption['sns1']}}<em>{{siteOption['sns1Id']}}</em></span>
              </li>
              <li v-if="siteOption['sns3']" @click="siteOption['sns3Link']">
                <img src="@/assets/img/zalo.svg" />
                <span>{{siteOption['sns3']}}<em>{{siteOption['sns3Id']}}</em></span>
              </li>
            </ul>
          </div> -->
        </div>
      </div>
    </div>

  </footer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Footer',
  computed: {
    ...mapState([
      'siteOption'
    ])
  }
}
</script>
<style scoped src="@/styles/footer.css"></style>
<style scoped src="@/styles/common.css"></style>
